"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegistryLink = exports.CODE_PACKAGE_TYPE_TO_LINK = void 0;
const code_1 = require("./code");
exports.CODE_PACKAGE_TYPE_TO_LINK = {
    [code_1.CodePackageType.CocoaPods]: (name) => `https://cocoapods.org/pods/${name}`,
    [code_1.CodePackageType.Gradle]: (name) => `https://mvnrepository.com/artifact/${name.split(':').join('/')}`,
    [code_1.CodePackageType.PackageJson]: (name) => `https://www.npmjs.com/package/${name}`,
    [code_1.CodePackageType.RequirementsTxt]: (name) => `https://pypi.org/project/${name}`,
    [code_1.CodePackageType.Swift]: (name) => `https://swiftpackageindex.com/search?query=${name}`,
    [code_1.CodePackageType.Pubspec]: (name) => `https://pub.dev/packages/${name}`,
    [code_1.CodePackageType.Gemfile]: (name) => `https://rubygems.org/gems/${name}`,
    [code_1.CodePackageType.ComposerJson]: (name) => `https://packagist.org/packages/${name}`,
};
/**
 * Get the registry link for a given code package
 *
 * @param name - Name of package
 * @param type - Type of registry
 * @returns The registry link
 */
function getRegistryLink(name, type) {
    return exports.CODE_PACKAGE_TYPE_TO_LINK[type](name);
}
exports.getRegistryLink = getRegistryLink;
//# sourceMappingURL=getRegistryLink.js.map